import styled from "styled-components";
export const Container = styled.section`
  margin-top: 15rem;
  overflow-x: hidden; /* Prevent horizontal scroll */

  h2 {
    text-align: center;
    font-size: 4rem;
    margin-bottom: 3rem;
  }

  .projects {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    padding: 1rem;
    width: 100%; /* Make sure grid stays inside */
    box-sizing: border-box;

    .project {
      padding: 2rem 1.8rem;
      background-color: #2b2b2b;
      border-radius: 1.2rem;
      transition: 0.25s;
      display: flex;
      flex-direction: column;
      height: 100%;
      color: #fff;
      max-width: 100%; /* prevent overflow */
      box-sizing: border-box;

      &:hover {
        transform: translateY(-5px);
        background-color: var(--pink);
      }

      header {
        display: flex;
        color: var(--blue);
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap; /* allow icons to wrap */
        margin-bottom: 2rem;

        .project-links {
          display: flex;
          align-items: center;
          gap: 1rem;

          a > img {
            width: 3.5rem; /* smaller icons */
            height: auto;
          }
        }
      }

      h3 {
        margin-bottom: 1.5rem;
        font-size: 2rem;
        word-wrap: break-word; /* Prevent long titles from breaking layout */
      }

      p {
        font-size: 1.4rem;
        line-height: 1.6;
        margin-bottom: 2rem;
      }
      p a {
        border-bottom: 1px solid var(--green);
        &:hover {
          color: var(--green);
        }
      }

      footer {
        margin-top: auto;

        .tech-list {
          display: flex;
          flex-wrap: wrap; /* allow wrapping */
          gap: 2rem;
          align-items: center;
          font-size: 1.4rem;
          opacity: 0.6;
        }
      }
    }
  }

  .project-image {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 1.5rem 0;

    img {
      width: 100%;
      max-width: 100%;
      height: auto;
      object-fit: cover;
      border-radius: 0.8rem;
    }
  }

  /* Tablet */
  @media (max-width: 1024px) {
    .projects {
      grid-template-columns: 1fr 1fr;
    }
  }

  /* Mobile */
  @media (max-width: 768px) {
    .projects {
      grid-template-columns: 1fr;
      padding: 0.5rem; /* reduce padding on mobile */
    }

    .project {
      padding: 1rem; /* tighter padding */
    }
  }
`;
